import React, { useState } from "react";
import TaxTypeTable from "./tax-type-table";
import TaxCombinationTable from "./tax-combination-table";
import InnerLayout from "../../../../layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import search from "../../../../../assets/icons/searchIcon.svg";
import TaxCombination from "./tax-combination-view";
import TabsComponent from "../../../../helper-components/tabs-component";
import LoadingButtonSpinner from "../../../../helper-components/loading-button-spinner";
import excelImg from "../../../../../assets/icons/excel.png";
import useCsvUpload from "../../../../helper-components/upload-csv-custom-hook";
import {
  taxCombinationImportAction,
  taxTypeImportAction,
} from "../../../../../redux/actions/settings-action";
import { downloadAllTemplates } from "../../../../helper-components/helper-function";
import DownloadIcon from "../../../../../assets/icons/download-icon";
import successToast from "../../../../helper-components/success-toast";
import { Search } from "lucide-react";

const TaxSetup = () => {
  const [currentTab, setCurrentTab] = useState("Tax Type");

  const taxTypeTemplateArray = [
    {
      documentType: "Tax-Type",
      expectedHeaders: ["name", "description"],
    },
  ];
  const taxCombinationTemplateArray = [
    {
      documentType: "Tax-Combination",
      expectedHeaders: [
        "tax_combination_code",
        "tax_type_name",
        "percentage",
        "sales_tax_acc",
        "purchase_tax_acc",
      ],
    },
  ];

  const taxTemplate =
    currentTab === "Tax Type"
      ? taxTypeTemplateArray
      : taxCombinationTemplateArray;

  const actionType =
    currentTab === "Tax Type"
      ? taxTypeImportAction
      : taxCombinationImportAction;

  const [reload, setReload] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [showAddEdit, setShowAddEdit] = useState(false);
  const navigate = useNavigate();

  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.data?.message);
  };
  const onError = (data) => {};
  const { handleFileUpload, loading } = useCsvUpload(
    actionType,
    taxTemplate?.[0]?.expectedHeaders
  );

  return (
    <InnerLayout
      list={true}
      title="Settings"
      module="tax-setup"
      // permissionFn={permissionFn}
    >
      <div className="my-2 mx-6 ">
        {/* <div className="flex justify-between pt-3">
          <div className="pl-2 pb-4 flex items-center gap-2 text-sm">
            <button
              className="flex items-center gap-2"
              onClick={() => {
                navigate("/settings");
              }}
            >
              <ChevronLeftIcon className="h-5 w-5 inline-block" />
              Settings /
            </button>
            <span className="cursor-pointer">{" " + "Tax Setup"}</span>
          </div>
          <div className="flex items-center gap-3 pr-3">
            <div
              style={{ minWidth: "18rem", height: "2.5rem" }}
              className={`input_border flex items-center rounded-md pb-1 w-10 `}
            >
              <span className="px-2">
                {" "}
                <img width={"16px"} src={search} alt="search icon" />
              </span>
              <input
                placeholder={`Search here`}
                className=" table_search_input w-full rounded-md text-xs placeholder:text-xs"
                type="text"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                }}
              />
              <span
                className="text-sm mx-3 cursor-pointer text-primary"
                onClick={() => setSearchValue("")}
              >
                Clear
              </span>
            </div>

            {currentTab === "Tax Combination" && (
              <div className="px-4">
                <button
                  type="submit"
                  className="bg-primary text-white px-6 py-2 rounded-md flex justify-center fw_500 text-sm whitespace-nowrap"
                  onClick={() => setShowAddEdit(true)}
                >
                  <span className="mx-1">+ New</span>
                </button>
              </div>
            )}
            <div>
              <input
                type="file"
                accept=".csv"
                onChange={(e) => handleFileUpload(e, onSuccess, onError)} // Pass onSuccess and onError functions
                className="hidden"
                id="csv-upload"
              />
              <label htmlFor="csv-upload">
                <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                  <img width={20} height={30} src={excelImg} alt="excel-icon" />
                  {loading ? (
                    <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                  ) : (
                    <span>Import</span>
                  )}
                </div>
              </label>
            </div>
            <button
              type="button"
              onClick={() => {
                downloadAllTemplates(taxTemplate);
              }}
              className="border-027A48 border-2 rounded-md px-2 py-2"
            >
              <DownloadIcon fill="var(--success-color)" />
            </button>
          </div>
        </div> */}
        <div className="flex justify-between items-center">
          <div className=" flex items-center gap-2 text-sml">
            <button
              className="flex items-center gap-2"
              onClick={() => {
                navigate("/settings");
              }}
            >
              <ChevronLeftIcon className="h-5 w-5 inline-block " />
              Data Setup Settings /
            </button>
            <span className="cursor-pointer">{" " + "Tax setup"}</span>
          </div>
          <div className="flex items-center gap-3 ">
            <div
              style={{ minWidth: "18rem", height: "2.5rem" }}
              className={`border border-[var(--search-input-border)] flex  justify-between items-center rounded-md  w-10 `}
            >
              <input
                // ref={searchRef}
                placeholder={`Search (/)`}
                className=" table_search_input px-3 py-2 !border-none !outline-none !ring-0 text-[length:var(--search-label-font-size)] font-[var(--search-place-font-weight)]"
                type="text"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                }}
              />
              <span className="px-2">
                {" "}
                {<Search size="16" color="#9CA3AF" />}
              </span>
            </div>
            {currentTab === "Tax Combination" && (
              <div className="px-4">
                <button
                  type="submit"
                  className="bg-primary text-white px-6 py-2 rounded-md flex justify-center fw_500 text-sm whitespace-nowrap"
                  onClick={() => setShowAddEdit(true)}
                >
                  <span className="mx-1">+ New</span>
                </button>
              </div>
            )}
            {currentTab !== "Department & role Mapping" && (
              <div className=" flex flex-row gap-3">
                <div>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => handleFileUpload(e, onSuccess, onError)} // Pass onSuccess and onError functions
                    className="hidden"
                    id="csv-upload"
                  />
                  <label htmlFor="csv-upload">
                    <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                      <img
                        width={20}
                        height={30}
                        src={excelImg}
                        alt="excel-icon"
                      />
                      {loading ? (
                        <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                      ) : (
                        <span>Import</span>
                      )}
                    </div>
                  </label>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    downloadAllTemplates(taxTemplate);
                  }}
                  className="border-027A48 border-2 rounded-md px-2 py-1"
                >
                  <DownloadIcon fill="var(--success-color)" />
                </button>
              </div>
            )}
          </div>
        </div>
        <TabsComponent
          handleClickfn={(item) => {
            setCurrentTab(item);
          }}
          itemTabs={itemTabs}
          setCurrentTab={setCurrentTab}
          currentTab={currentTab}
        />
        {currentTab === "Tax Type" && (
          <div>
            <TaxTypeTable reload={reload} searchValue={searchValue} />
          </div>
        )}
        {currentTab === "Tax Combination" && (
          <div>
            {showAddEdit ? (
              <TaxCombination
                isView={false}
                editingData={null}
                toogleChange={() => setShowAddEdit(!showAddEdit)}
                reloadData={() => setShowAddEdit(!showAddEdit)}
              />
            ) : (
              <TaxCombinationTable reload={reload} searchValue={searchValue} />
            )}
          </div>
        )}
      </div>
    </InnerLayout>
  );
};

export default TaxSetup;

const itemTabs = ["Tax Type", "Tax Combination"];
